import { jsx as b } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import d from "@mui/material/Tabs";
import p from "styled-components";
const x = {
  root: "tabsRoot",
  indicator: "tabsIndicator",
  scrollButtons: "tabsScrollButtons",
  flexContainerVertical: "tabsFlexContainerVertical",
  vertical: "tabsVertical",
  flexContainer: "tabsFlexContainer"
}, o = (t) => t === "left" ? "flex-start" : t === "right" ? "flex-end" : "center", u = p(d).withConfig({
  displayName: "StyledTabs"
})([
  "&&.tabsRoot{min-height:30px;margin:0;background-color:",
  ";border-bottom:1px solid ",
  ";}&& .tabsScrollButtons{color:",
  ";}&& .tabRoot{justify-content:",
  ";}&& .tabRoot.Mui-focusVisible{border:1px solid ",
  ";border-radius:4px;}&& .tabsFlexContainer:not(.tabsFlexContainerVertical) + .tabsIndicator{background-color:",
  ";height:3px;transition:",
  ";}&& .tabsFlexContainer:not(.tabsFlexContainerVertical) > .tabRoot:active:after{content:'';height:3px;width:100%;position:absolute;background-color:",
  ";bottom:0px;}&& .tabsFlexContainer:not(.tabsFlexContainerVertical) > .tabRoot.tabDisabled.tabSelected:after{content:'';height:3px;width:100%;position:absolute;bottom:0px;background-color:",
  ";z-index:1;}&&.tabsRoot.tabsVertical{border-right:1px solid ",
  ";border-bottom:none;}&& .tabsFlexContainerVertical + .tabsIndicator{background-color:",
  ";width:3px;transition:",
  ";}&& .tabsFlexContainerVertical > .tabRoot:active:after{content:'';width:3px;height:100%;position:absolute;right:0px;background-color:",
  ";}&& .tabsFlexContainerVertical > .tabRoot.tabDisabled.tabSelected:after{content:'';width:3px;height:100%;position:absolute;right:0px;background-color:",
  ";z-index:1;}&& .tabsFlexContainerVertical > .tabRoot{justify-content:",
  ";}"
], ({ theme: t }) => t.primaryBackground, ({ theme: t }) => t.primaryBorder, ({ theme: t }) => t.primaryFill, ({ $labelAlignment: t }) => o(t), ({ theme: t }) => t.primaryFill, ({ theme: t }) => t.primaryFill, ({ $noTransition: t }) => t ? "none" : void 0, ({ theme: t }) => t.primarySelected, ({ theme: t }) => t.secondaryDisabled, ({ theme: t }) => t.primaryBorder, ({ theme: t }) => t.primaryFill, ({ $noTransition: t }) => t ? "none" : void 0, ({ theme: t }) => t.primarySelected, ({ theme: t }) => t.secondaryDisabled, ({ $labelAlignment: t }) => o(t)), m = /* @__PURE__ */ c(({ children: t, classes: e, noTransition: r = !0, labelAlignment: a = "center", variant: i = "scrollable", value: n = !1, ...l }, s) => /* @__PURE__ */ b(u, {
  ...l,
  ref: s,
  classes: {
    ...x,
    ...e
  },
  $noTransition: r,
  $labelAlignment: a,
  variant: i,
  value: n,
  children: t
}));
m.displayName = "Tabs";
export {
  m as default
};
